//追缴规则
const RuleConfiguration = () => import(/*webpackChunkName:'sale'*/"@/page/sale/recoveryRules/ruleConfiguration.vue")
const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')

export  const recoveryRules=
    {
        path: '/main/recovery-rules',
        name: '追缴规则',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/recovery-rules/rule-configuration',
            name: '规则设置',
            meta: {
                requireAuth: true,
            },
            component: RuleConfiguration
        },
       ]
    }